export enum HintType {
  NoHint,
  Error,
  Info,
}
